import { NSARouterMakerResult } from "namirasoft-account-react";
import { ClassifierFullRow, ClassifierInputRow, ClassifierRow } from "namirasoft-inference";
import { Component } from "react";
import ClassifierClassesView from "../components/ClassifierClassesView";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ClassifierViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ClassifierViewPage extends Component<ClassifierViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout<ClassifierRow, ClassifierInputRow>
                {...this.props}
                action={{ description: InferenceInfo.classifier.view }}
                pages={{
                    entity: InferenceEntities.classifier(this.props),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Classes",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    let full = model.row as ClassifierFullRow | null;
                                                    return (
                                                        <ClassifierClassesView
                                                            {...this.props}
                                                            classifier_id={model.id}
                                                            rows={full?.classes ?? []}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    }
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}